import type {AlertColor} from '@mui/material'
import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import {showSnackbar} from '@redux/slices/snackbar'

export const useSnackbar = (): [
  (snackbar: {message: string; severity: AlertColor | undefined; action?: string}) => void,
] => {
  const dispatch = useDispatch()
  const showSnackbarFn = useCallback(
    (snackbar: {message: string; severity: AlertColor | undefined; action?: string}): void => {
      const action = snackbar.action ? snackbar.action : ''
      dispatch(
        showSnackbar({
          message: snackbar.message,
          severity: snackbar.severity,
          action,
        }),
      )
    },
    [dispatch],
  )
  return [showSnackbarFn]
}
